var cookieModalFocus = (function () {
    var cookieWall = document.querySelector(".cookie-wall");
    var cookieModalLink = cookieWall.querySelector(".cookie-policy-link");
    var cookieModalBtn1 = cookieWall.querySelector("#button-save-all");
    var cookieModalBtn2 = cookieWall.querySelector(".save-cookie-prefs");
    var cookieWallDetails = cookieWall.querySelector("details");

    function setFocus(element) {
        if (element) {
            element.focus();
        }
    }

    function init() {
        if (!cookieModalLink || !cookieWall.classList.contains("open")) {
            return;
        }
        setFocus(cookieModalLink);

        document.addEventListener("keydown", onTabPress);
    }

    function onTabPress(event) {
        if (!cookieWall.classList.contains("open")) {
            return;
        }

        var activeElem = event.target;

        if (event.key === "Tab") {
            if (!event.shiftKey) {
                if (activeElem === cookieModalBtn1 || activeElem === cookieModalBtn2) {
                    event.preventDefault();
                    setFocus(cookieModalLink);
                }
            } else if (activeElem === cookieModalLink) {
                event.preventDefault();
                setFocus(cookieWallDetails.hasAttribute("open") ? cookieModalBtn2 : cookieModalBtn1);
            }
        }
    }

    return {
        init: init,
    };
})();

window.addEventListener("load", function () {
    cookieModalFocus.init();
});
